import { createSlice } from "@reduxjs/toolkit";
import {
  getMeristemState,
  MeristemExperiment,
  Targeting,
} from "src/utils/meristemContext";
import { ReadonlyDeep } from "type-fest";

export type StartEvent = ReadonlyDeep<{ filters?: Targeting[] }>;
export type StartEventsState = Record<
  /** experimentName */ string,
  Record</** eventName */ string, StartEvent>
>;
/**
 * Returns an object of Meristem experiments and their startEvents
 * This object is in the shape of
 * {
 *   experimentName: { startEvent: { filters }, ... },
 *   ...
 * }
 */
function extractStartEvents(
  meristemExperiments: ReadonlyDeep<MeristemExperiment[]>
): StartEventsState {
  const startEvents: StartEventsState = {};
  if (meristemExperiments) {
    meristemExperiments.forEach((meristemExperiment) => {
      const experimentName = meristemExperiment.name;
      if (meristemExperiment.startEvents) {
        startEvents[experimentName] = {};
        meristemExperiment.startEvents.forEach((startEvent) => {
          const { filters } = startEvent;
          startEvents[experimentName][startEvent.name] = {
            filters,
          };
        });
      }
    });
  }
  return startEvents;
}

const startEventsSlice = createSlice({
  name: "startEvents",
  initialState: extractStartEvents(getMeristemState()?.experiments),
  reducers: {},
});

export default startEventsSlice.reducer;
